import React from "react";
import PropTypes from "prop-types";
import "../layout.css";
import { storage } from "../config";
import Section from '../components/Section';

export default class Changes extends React.Component {
    render() {
        const storageRef = storage.ref().child('/8Changes');
        const { DeviceWidth } = this.props;
        return (
           <div style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: DeviceWidth <= 700 ? 'center' : 'flex-start',
            }}>
               <h1>Welcome to the Changes page</h1>
               <h4>Below are links to all additional files</h4>
               <ul>
                   <li>
                    <a href="https://firebasestorage.googleapis.com/v0/b/sepr-docs.appspot.com/o/Change%20Management%20log.pdf?alt=media&token=d85d5cef-dfd8-4f81-8484-7e060f5fc91b" rel="noopener noreferrer" target="_blank">
                        <h4>Change Management Log</h4>
                    </a>
                   </li>
               </ul>
               <Section storageRef={storageRef} DeviceWidth={DeviceWidth} withControls={true} />
           </div>
        );
    }
}

Changes.propTypes = {
    DeviceWidth: PropTypes.number,
};

Changes.defaultProps = {
    DeviceWidth: 0,
};
